var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bridge8-autocomplete',{staticClass:"mt-1 mb-0",attrs:{"outline":"","label":"Client","null-value-string":"Net Rate","data":_vm.clients,"search-string":_vm.client},on:{"change":function($event){return _vm.$emit('change', $event)}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1c9fcb8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AdminClientSelect.vue
// module id = null
// module chunks = 